import React, { useRef, useState } from 'react'
import '../Login/Login.scss'
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { postlogin } from '../Services/BackendUrl';
import axios from 'axios';
import { Toast } from 'primereact/toast';
import { Password } from 'primereact/password';
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import CryptoJS from "crypto-js";

 

const Login = () => {
  const toast = useRef(null);
  const [ isLogin, setIslogin ] =  useState({
    username:'',
    password:''
  })

  const SECRET_KEY = "vfdfhjgfdfsrfjkjhjgfdrsadxfcgjkuytfhdtzsrfxgchgjkhgsfzxgcxhjgkyhghfgdfstjdghfxdftgdht"; // Must match server key

  function encryptData(data) {
      return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setIslogin((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handlesubmit= async(e)=>{
    e.preventDefault();
    try{
      const encryptedPayload = encryptData( isLogin);
      const response = await axios.post(postlogin, { encryptedData :encryptedPayload })
      const responseMessage = String(response?.data?.message || "").toLowerCase();
      const isSuccess =
        response?.status === 200 &&
        (responseMessage.includes("success") ||
          response?.data?.success === true ||
          Boolean(response?.data?.token) ||
          Boolean(response?.data?.accessToken));

      if (isSuccess) {
        sessionStorage.setItem("isAdminAuthenticated", "true");
        localStorage.setItem("isAdminAuthenticated", "true");
        window.location.replace("/admin/adminpage");
      }
    }
    catch(error){
    const errorMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    "Something went wrong";
        toast.current.show({ 
          severity: 'custom',
          life:3000,
          content: (
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor:'#FF7F5077', color:'white', width:'90%' }}>
              <i className="pi pi-exclamation-triangle" style={{ fontSize: '1.5rem', padding:'20px' }}></i>
              <span>{errorMessage}</span>
            </div>
          ),
        });
    }
  }
  return (
    <div className="login-main-container">
      <Toast ref={toast} />
      <div className="login-border-box">
        <div className='login-container'>
          <strong className='login-title'>LOGIN<span style={{ color: 'orange' }}>.</span></strong>

          <form onSubmit={handlesubmit} style={{ display: 'flex', flexDirection: 'column', gap: '40px', color: 'white', paddingTop: '30px' }}>
            <div className='login-input-field'>
              <label>User name</label>
              <InputText name='username' value={isLogin.username} onChange={handleChange} className='login-input' />
            </div>

            <div className='login-input-field'>
              <label>Password</label>
              <Password name='password' value={isLogin.password} onChange={handleChange} toggleMask feedback={false} className='login-input'/>
            </div>

            <Button 
              type="submit"
              icon='pi pi-arrow-right' 
              style={{ background: '#F58220', border: 'none', borderRadius: 0, padding: '15px 0', display: 'flex', flexDirection: 'row-reverse', justifyContent: 'center', gap: '15px', cursor:'pointer' }}
            >
              Sign Up
            </Button>
          </form>
        </div>

        <div style={{marginTop:'45%', marginRight:'-10%'}}>
          <div className='login-right'>WELCOME TO KOSMOS PORTAL</div>
          <p className='login-description'>Login to access your account</p>
        </div>
      </div>

    </div>
  )
}

export default Login;